import { ReactNode } from 'react';

export function CatalogFormField({ name, label, error, children }: { name: string; label: string; error?: string; children: ReactNode }) {
  return (
    <div className="admin-field">
      <label htmlFor={name}>{label}</label>
      {children}
      {error ? <span className="form-field-error" id={`${name}-error`} role="alert">{error}</span> : null}
    </div>
  );
}
